import { AlertCircle } from "lucide-react";
import type { ComponentBlock } from "@/lib/blocks";

export function InvalidBlock({ block }: { block: ComponentBlock }) {
  return (
    <figure className="overflow-hidden rounded-xl border border-dashed bg-muted/30">
      <pre className="overflow-x-auto px-4 py-3 font-mono text-[0.8rem] leading-relaxed text-foreground/80">
        <code>{block.raw}</code>
      </pre>
      <figcaption className="flex items-center gap-1.5 border-t border-dashed px-4 py-1.5 text-xs text-muted-foreground">
        <AlertCircle className="size-3.5 shrink-0 text-tone-warning" aria-hidden />
        <span>
          invalid component: {block.error ?? `unknown "${block.name}"`}
        </span>
      </figcaption>
    </figure>
  );
}
